import React, { Component } from "react";
import moment from "moment";
import ScrollAnimation from "../../shared/ScrollAnimation/ScrollAnimation";

export default class EventsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [],
    };
    this.getEvents = this.getEvents.bind(this);
  }

  componentDidMount() {
    this.getEvents();
  }

  componentDidUpdate() {}

  getEvents() {
    fetch(process.env.REACT_APP_API_BASE_URL + "/fixtures/next-home/5", {
      method: "GET",
    })
      .then((res) => res.json())
      .then(
        (json) => {
          this.setState({
            events: json,
          });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  render() {
    return (
      <div>
        <section id="events" className="events-container">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2>Események</h2>
              </div>
              <div className="col-12 padding5 flex">
                {this.state.events.map((item, index) => (
                    <div className="event-item__container" key={item.id}>
                      <div className="event-item__content">
                        <div className="crests">
                          <img
                            src={`${process.env.REACT_APP_STATIC_SERVER_URL}/web/images/crests/${item.home_squad_crest}`}
                            alt=""
                          />
                          <span>VS</span>
                          <img
                            src={`${process.env.REACT_APP_STATIC_SERVER_URL}/web/images/crests/${item.away_squad_crest}`}
                            alt=""
                          />
                        </div>
                        <div className="kickoff">
                          <p>
                            {moment(item.event_date).format("YYYY.MM.DD HH:mm")}
                            <br />
                            {item.event_location}
                          </p>
                        </div>
                        <div className="type">
                          <p>{item.event_name}</p>
                        </div>
                      </div>
                    </div>
                ))}

                {this.state.events.length === 0 && (
                  <div className="col-12">
                    <h3 className="no-actual-event">Nincs aktuális esemény</h3>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
